<template>
	<div class="ServiceHistory">
		<div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<card card-body-classes="table-full-width">			
			<div>
				<div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
					<!--base-input>
						<el-input
							type="search"
							class="mb-3 search-input"
							clearable
							prefix-icon="el-icon-search"
							placeholder="Поиск"
							v-model="searchQuery"
							aria-controls="datatables"
						>
						</el-input>
					</base-input-->
				</div>
				<el-table :data="masHistory" class="my_hover">
					<el-table-column
						min-width="170"
						prop="dwl_date"
						label="Дата изменения"
					>
					</el-table-column>
					<el-table-column
						min-width="160"
						prop="OLD_STATUS"
						label="Старое значение"
					>
					</el-table-column>
					<el-table-column
						min-width="160"
						prop="NEW_STATUS"
						label="Новое значение"
					>
					</el-table-column>
					<!-- <el-table-column
						min-width="160"
						prop="old_STAGE_NAME"
						label="old_STAGE_NAME"
					>
					</el-table-column>
					<el-table-column
						min-width="160"
						prop="new_STAGE_NAME"
						label="new_STAGE_NAME"
					>
					</el-table-column> -->
					<el-table-column
						min-width="160"
						prop="old_agent_name"
						label="Кто был"
					>
					</el-table-column>
					<el-table-column
						min-width="160"
						prop="new_agent_name"
						label="Кто стал"
					>
					</el-table-column>
					<el-table-column
						min-width="160"
						prop="editor_name"
						label="Кто изменил editor_name"
					>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
				<Pagination :class="[{'': parseInt(history_total) > 0}, {'d-none': parseInt(history_total) < 1}]"
					:type="'primary'" 
					:total="parseInt(history_total)" 
					:perPage="parseInt(20)" 
					:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
					:pClick="pClick">
				</Pagination>
			</div>
		</card>
	</div>
</template>
<script>
/*
{"id":"16","service_id":"115","dwl_date":"2021-04-01 10:32:35","OLD_STATUS":"В работе","NEW_STATUS":"В работе","old_agent_id":"8023","old_agent_name":"Сосновский Артем Сергеевич","new_agent_id":"10420","new_agent_name":"Воеводова Мария Валерьевна"}
 */
import { Table, TableColumn } from 'element-ui';
import Pagination from 'src/our_components/RePagination';
export default {
	name: 'Service_history-page',
	components: {
		Pagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			masHistory: [],
			history_total:0,
			searchQuery:'',
			objGetParams: {},
		};
	},
	methods: {
		getHistory(){
			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.$route.params.service_id != 'undefined'){
				const service_id = typeof this.$route.params.service_id == 'undefined'?'':this.$route.params.service_id;
				this.$GVO.ApiCall('GET_SERVICE_HIST',{obj:'services',flt:{service_id:service_id}})
				.then((objApi) => {
					this.history_total=0;
					this.masHistory = [];
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.masHistory = objApi.data;
							if(objApi.total!=undefined) { this.history_total=objApi.total; }
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});

			this.getHistory();
		},	
		GoBack(){
			this.$router.back();
		},

	},
	mounted() {
		this.getHistory();
	}
};
</script>
<style>
	.el-table.my_hover .el-table__body tr:hover > td{
		background-color: rgb(1, 176, 224, 0.33) !important;
		cursor: pointer;
	}
	.ServiceHistory .bntGroup{
		position: absolute;
		z-index: 1;
		right: 40px;
	}
</style>
